import { toast } from 'react-toastify';
import { ContactSupportId } from '../constants/constants';
import { ErrorListOutput } from '../types';
import { ToastOptions } from 'react-toastify/dist/types';

export type ResponseErrorType = {
  response?: {
    data?: ErrorListOutput
  }
}

const DEFAULT_ERROR = `We are having some trouble, Please contact support for help. id: ${ContactSupportId.showError}`;

export function showError(errorMessage: string = DEFAULT_ERROR, options?: ToastOptions) {
  toast(errorMessage, {
    ...options,
    type: 'error'
  });
}

export function showErrorAndCode(error: ResponseErrorType, contactSupportId: ContactSupportId) {
  if (error?.response?.data?.errors) {
    return showError(error.response.data.errors[0].message);
  }

  showError(`We are having some trouble, Please contact support for help. id: ${contactSupportId}`);
}
